
import { PAGES } from "@consts";

export default {
	name: "CrosswordClueList",
	props: {
		clues: {
			type: Array,
			required: true,
		},
	},
	computed: {
		showAnswer() {
			return this.$route.name === PAGES.CLUES_PUBLISHER;
		},
	},
};
